<template>
  <div class="policy-public">
    <b-card class="mb-2">
      <h1 class="mb-2">Política de Privacidad</h1>
      <p>
        En Shireo, valoramos y protegemos tu privacidad. Esta política explica cómo recopilamos, usamos y protegemos tus datos personales cuando utilizas nuestra aplicación móvil.
      </p>
      <h2>1. Información que recopilamos</h2>
      <ul>
        <li>Datos de registro: nombre, correo electrónico, empresa y otros datos necesarios para el uso de la app.</li>
        <li>Datos de uso: información sobre cómo utilizas la aplicación, como accesos, acciones y preferencias.</li>
        <li>Datos técnicos: modelo de dispositivo, sistema operativo, dirección IP y otros datos técnicos.</li>
      </ul>
      <h2>2. Uso de la información</h2>
      <ul>
        <li>Para gestionar tu cuenta y ofrecerte los servicios de Shireo.</li>
        <li>Para mejorar la experiencia de usuario y el funcionamiento de la app.</li>
        <li>Para cumplir con obligaciones legales y de seguridad.</li>
      </ul>
      <h2>3. Compartir información</h2>
      <ul>
        <li>No compartimos tus datos personales con terceros, salvo obligación legal o para prestar el servicio.</li>
        <li>Podemos compartir datos anonimizados para análisis y mejoras.</li>
      </ul>
      <h2>4. Seguridad</h2>
      <ul>
        <li>Aplicamos medidas técnicas y organizativas para proteger tus datos.</li>
        <li>Solo personal autorizado puede acceder a la información.</li>
      </ul>
      <h2>5. Derechos del usuario</h2>
      <ul>
        <li>Puedes acceder, rectificar o eliminar tus datos personales en cualquier momento.</li>
        <li>Para ejercer tus derechos, contacta con soporte@shireo.com.</li>
      </ul>
      <h2>6. Cambios en la política</h2>
      <p>
        Podemos actualizar esta política de privacidad. Te notificaremos los cambios relevantes a través de la app.
      </p>
      <h2>7. Contacto</h2>
      <p>
        Si tienes dudas sobre esta política, escríbenos a soporte@shireo.com.
      </p>
    </b-card>
  </div>
</template>

<script>
import { BCard } from 'bootstrap-vue'
export default {
  components: {
    BCard,
  },
}
</script>

<style scoped>
  .policy-public {
    max-width: 700px;
    margin: 0 auto;
    padding: 2rem 1rem;
  }
</style>
